module.exports = __webpack_public_path__ + "static/media/paperclip.6742b5ce.svg";